<div class="header-wrapper">
  <div class="head-row">
    <h1 class="head-row__dialog-title truncate" mat-dialog-title>Packungseinheiten zuordnen</h1>
    <button mat-icon-button mat-dialog-close class="head-row__dialog-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <p class="dialog-text">Hier können Packungseinheiten per Datenquelle zugeordnet werden.</p>

  <mp-dropdown
    class="dialog-dropdown"
    [options]="datasourcesOptions"
    label="Datenquelle auswählen"
    dropdownIcon="topic"
    [selectedValue]="initialDataSourceOption"
    (selectedValueChange)="datasourceChanged($event)"
  />
</div>

<div mat-dialog-content class="dialog-content">
  <div class="table-container">
    <table mat-table class="packaging-units-table top-border" [dataSource]="tableData">
      <div *matNoDataRow class="no-data-row">Keine Daten</div>

      <ng-container matColumnDef="einheit">
        <mat-header-cell
          class="packaging-units-table__header-cell packaging-units-table__header-cell-unit truncate"
          *matHeaderCellDef
          title="Einheiten"
          >Einheiten</mat-header-cell
        >
        <mat-cell class="packaging-units-table__cell packaging-units-table__cell-unit" *matCellDef="let einheit">{{
          einheit.shortName
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="artikel">
        <mat-header-cell
          class="packaging-units-table__header-cell packaging-units-table__header-cell-article truncate"
          *matHeaderCellDef
          title="Artikel"
          >Artikel</mat-header-cell
        >
        <mat-cell class="packaging-units-table__cell packaging-units-table__cell-article" *matCellDef="let einheit">{{
          einheit.frequency
        }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="bezugsquelle">
        <mat-header-cell
          class="packaging-units-table__header-cell packaging-units-table__header-cell-assigned-unit truncate"
          *matHeaderCellDef
          title="Zugeordnete Einheit"
          >Zugeordnete Einheit</mat-header-cell
        >
        <mat-cell
          class="packaging-units-table__cell packaging-units-table__cell-assigned-unit"
          *matCellDef="let einheit"
        >
          @if (einheit.mappedShortName) {
            {{ einheit.mappedShortName }} ({{ einheit.mappedLongName }})

            <button class="action-button" mat-icon-button (click)="deleteEinheitsMapping(einheit)">
              <mat-icon>close</mat-icon>
            </button>
          } @else {
            <mp-packungseinheiten-selector
              [packagingUnits]="optionen"
              [value]="einheit"
              (emitChanged)="emitEinheitChanged(einheit, $event)"
              [cache]="assignedEinheit()"
            />

            <button class="action-button" mat-icon-button (click)="saveEinheit(einheit)">
              <mat-icon>check</mat-icon>
            </button>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="einheitenCols()" />
      <mat-row *matRowDef="let row; columns: einheitenCols()" />
    </table>

    <ng-container *ngrxLet="einheitenPagination$ as einheitenPagination">
      @if (einheitenPagination.totalRowCount > pageCount()) {
        <mp-paginator [pagination]="einheitenPagination" (page)="emitPageChanges($event)" />
      }
    </ng-container>
  </div>
</div>
